var _rect, _g, _rect2, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgKycScreenings(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 4,
    width: 48,
    height: 48,
    rx: 24,
    fill: "#E3F2FD"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_7647_16237)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M31.5 30H30.71L30.43 29.73C31.41 28.59 32 27.11 32 25.5C32 21.91 29.09 19 25.5 19C21.91 19 19 21.91 19 25.5C19 29.09 21.91 32 25.5 32C27.11 32 28.59 31.41 29.73 30.43L30 30.71V31.5L35 36.49L36.49 35L31.5 30ZM25.5 30C23.01 30 21 27.99 21 25.5C21 23.01 23.01 21 25.5 21C27.99 21 30 23.01 30 25.5C30 27.99 27.99 30 25.5 30Z",
    fill: "#448AFF"
  }))), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 4,
    width: 48,
    height: 48,
    rx: 24,
    stroke: "#F8FCFF",
    strokeWidth: 8
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_7647_16237"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(16 16)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKycScreenings);
export default __webpack_public_path__ + "static/media/kycScreenings.97fd4e5cf9efc270f8a77b029a8367a3.svg";
export { ForwardRef as ReactComponent };